import { fetchWrapper, IBaseResponse } from '../apiBase';
import { BASE_API_URL } from '@/config/environment';

export type IBaseImage = {
  id: string;
  description: string;
  image_definition: string;
  inserted_at: string;
  updated_at: string;
  is_default: boolean;
  tags: string[];
};

export interface IBaseImageResponse extends IBaseResponse {
  base_image: IBaseImage;
}

export interface IBaseImageListResponse extends IBaseResponse {
  notebook_base_images: IBaseImage[];
}

type INotebookImage = {
  build_script: string;
  description: string;
  filepath: string;
  id: string;
  inserted_at: string;
  is_private: boolean;
  name: string;
  organization_id: string | null;
  repository_id: string;
  updated_at: string;
  user_id: string;
};

export type INotebookConfig = {
  notebook_base_image: IBaseImage;
  notebook_image: INotebookImage;
  cpu_cores: number;
  gpu_model: string;
  memory_mb: number;
};

export interface INotebookConfigResponse extends IBaseResponse {
  notebook_config: INotebookConfig;
}

export async function fetchBaseImage(id: string, token?: string): Promise<IBaseImageResponse> {
  const targetUrl = `${BASE_API_URL}/notebook_base_images/${id}`;

  return await fetchWrapper({
    resourceName: 'notebook/base_image',
    targetUrl,
    authToken: token,
    resourceContext: { id },
  });
}

export async function fetchBaseImageList(token?: string): Promise<IBaseImageListResponse> {
  const targetUrl = `${BASE_API_URL}/notebook_base_images`;

  return await fetchWrapper({
    resourceName: 'notebook/base_image',
    targetUrl,
    authToken: token,
  });
}

export async function fetchNotebookConfig({
  namespace,
  repositoryName,
  resourcePath,
  token,
}: {
  namespace: string;
  repositoryName: string;
  resourcePath: string;
  token?: string;
}): Promise<INotebookConfigResponse> {
  const targetUrl = `${BASE_API_URL}/repos/${namespace}/${repositoryName}/notebooks/config/${resourcePath}`;
  console.log('fetchNotebookConfig > targetUrl', targetUrl);
  return await fetchWrapper({
    resourceName: 'notebookConfig',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName, resourcePath },
  });
}
